import script from "./StatisticPage.vue?vue&type=script&setup=true&lang=js"
export * from "./StatisticPage.vue?vue&type=script&setup=true&lang=js"

import "./StatisticPage.vue?vue&type=style&index=0&id=79f3918b&scoped=true&lang=css"

import exportComponent from "/home/guenter/Entwicklung/technic-gmbh/transparent-charge-app/webapp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-79f3918b"]])

export default __exports__